import XSmall from './src/x-small-combined';
export default XSmall;